import { render } from "./DaftarGaleri.vue?vue&type=template&id=cf04b23c"
import script from "./DaftarGaleri.vue?vue&type=script&lang=js"
export * from "./DaftarGaleri.vue?vue&type=script&lang=js"

import "./DaftarGaleri.vue?vue&type=style&index=0&id=cf04b23c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__